import Utils from './Utils'

export default [
  {
    id: 'estimationId',
    default: 'new_estimation',
    sample: '1234'
  },
  {
    id: 'estimationType',
    default: 'real',
    sample: 'real'// real or template
  },
  {
    id: 'estimationCategoryId',
    default: 'default',
    sample: 'default'
  },
  {
    id: 'estimationTitle',
    default: null,
    sample: 'オリンピック聖火台建設工事'
  },
  {
    id: 'estiamtionprimeContractor',
    default: null,
    sample: '旭川製鉄'
  },
  {
    id: 'currentFormInputId',
    default: null,
    sample: null
  },
  {
    id: 'estimationKatawakuSuuryou',
    default: 0,
    sample: 12000
  },
  {
    id: 'estimationHukurihiTanka',
    default: 0,
    sample: 425
  },
  {
    id: 'primeContractorInputMode',
    default: true,
    sample: true
  },
  {
    id: 'estimationPrefectureId',
    default: 13,
    sample: 13
  },
  {
    id: 'estimationYearMonthId',
    default: Utils.getIntYM(),
    sample: Utils.getIntYM()
  },
  {
    id: 'estiamtionprimeContractor',
    default: null,
    sample: '(株)鴻池組'
  },
  {
    id: 'estimationConfigTax',
    default: 10,
    sample: 10
  },
  {
    id: 'estimationHeaderPlace',
    default: null,
    sample: null
  },
  {
    id: 'estimationHeaderNote1',
    default: null,
    sample: null
  },
  {
    id: 'estimationHeaderNote2',
    default: null,
    sample: null
  },
  {
    id: 'estimationHeaderDeadline',
    default: null,
    sample: null
  },
  {
    id: 'estimationHeaderDueDate',
    default: null,
    sample: null
  },
  {
    id: 'estimationHeaderShitsugi',
    default: null,
    sample: null
  },
  {
    id: 'estimationHeaderKojiNumber',
    default: null,
    sample: null
  },
  {
    id: 'estimationHeaderKomokuNumber',
    default: null,
    sample: null
  },
  {
    id: 'estimationHeaderGyoshaCode',
    default: null,
    sample: null
  },
  {
    id: 'estimationHeaderCompanyName',
    default: null,
    sample: '後町建設工業㈱'
  },
  {
    id: 'estimationHeaderCompanyAddress',
    default: null,
    sample: '東京都渋谷区代々木3-16-1'
  },
  {
    id: 'estimationHeaderCompanyPhoneNumber',
    default: null,
    sample: '03-3379-5167'
  },
  {
    id: 'estimationHeaderCompanyFAXNumber',
    default: null,
    sample: '03-3379-5177'
  },
  {
    id: 'estimationBodyHeadLine1',
    default: null,
    sample: null
  },
  {
    id: 'estimationBodyHeadLine2',
    default: null,
    sample: null
  },
  {
    id: 'estimationBodyPrimeContractorMaterialCost',
    default: null,
    sample: null
  },
  {
    id: 'estimationBodyKatawakuUnpanhi',
    default: 0,
    sample: 250
  },
  {
    id: 'estimationBodyPrimeContractorKatawakuUnpanhi',
    default: null,
    sample: null
  },
  {
    id: 'estimationBodyNebiki',
    default: 0,
    sample: 6400
  },
  {
    id: 'estimationBodyPrimeContractorNebiki',
    default: null,
    sample: null
  },
  {
    id: 'estimationBodyKanyuuritsu',
    default: 100,
    sample: 52
  },
  {
    id: 'estimationBodyAnzenKanriHiRitsu',
    default: 0,
    sample: 20
  },
  {
    id: 'estimationBodyIppanKanriHiRitsu',
    default: 0,
    sample: 20
  },
  {
    id: 'uchiwakeList',
    default: [
      {name: '基礎型枠',
        specification: null,
        suuryou: null,
        tani: '㎡',
        isKatawakuSuuryou: true,
        daikuBugakari: null,
        daikuNinku: null,
        kaitaiBugakari: null,
        kaitaiNinku: null,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: null,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: null,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: null,
        meterialKouseizaiNote: null},
      {name: '地下型枠',
        specification: null,
        suuryou: null,
        tani: '㎡',
        isKatawakuSuuryou: true,
        daikuBugakari: null,
        daikuNinku: null,
        kaitaiBugakari: null,
        kaitaiNinku: null,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: null,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: null,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: null,
        meterialKouseizaiNote: null},
      {name: '地上型枠',
        specification: null,
        suuryou: null,
        tani: '㎡',
        isKatawakuSuuryou: true,
        daikuBugakari: null,
        daikuNinku: null,
        kaitaiBugakari: null,
        kaitaiNinku: null,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: null,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: null,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: null,
        meterialKouseizaiNote: null},
      {name: null,
        specification: null,
        suuryou: null,
        tani: null,
        isKatawakuSuuryou: true,
        daikuBugakari: null,
        daikuNinku: null,
        kaitaiBugakari: null,
        kaitaiNinku: null,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: null,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: null,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: null,
        meterialKouseizaiNote: null},
      {name: null,
        specification: null,
        suuryou: null,
        tani: null,
        isKatawakuSuuryou: true,
        daikuBugakari: null,
        daikuNinku: null,
        kaitaiBugakari: null,
        kaitaiNinku: null,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: null,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: null,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: null,
        meterialKouseizaiNote: null},
      {name: null,
        specification: null,
        suuryou: null,
        tani: null,
        isKatawakuSuuryou: true,
        daikuBugakari: null,
        daikuNinku: null,
        kaitaiBugakari: null,
        kaitaiNinku: null,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: null,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: null,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: null,
        meterialKouseizaiNote: null},
      {name: null,
        specification: null,
        suuryou: null,
        tani: null,
        isKatawakuSuuryou: true,
        daikuBugakari: null,
        daikuNinku: null,
        kaitaiBugakari: null,
        kaitaiNinku: null,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: null,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: null,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: null,
        meterialKouseizaiNote: null},
      {name: null,
        specification: null,
        suuryou: null,
        tani: null,
        isKatawakuSuuryou: true,
        daikuBugakari: null,
        daikuNinku: null,
        kaitaiBugakari: null,
        kaitaiNinku: null,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: null,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: null,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: null,
        meterialKouseizaiNote: null},
      {name: null,
        specification: null,
        suuryou: null,
        tani: null,
        isKatawakuSuuryou: true,
        daikuBugakari: null,
        daikuNinku: null,
        kaitaiBugakari: null,
        kaitaiNinku: null,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: null,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: null,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: null,
        meterialKouseizaiNote: null}
    ],
    sample: [
      {name: '基礎型枠',
        specification: null,
        suuryou: 1000,
        tani: '㎡',
        isKatawakuSuuryou: true,
        daikuBugakari: 12,
        daikuNinku: 83.3,
        kaitaiBugakari: 40,
        kaitaiNinku: 25,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: 600,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: 180,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: 120,
        meterialKouseizaiNote: null},
      {name: '地下型枠',
        specification: null,
        suuryou: 2000,
        tani: '㎡',
        isKatawakuSuuryou: true,
        daikuBugakari: 8,
        daikuNinku: 250,
        kaitaiBugakari: 30,
        kaitaiNinku: 66.7,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: 1200,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: 180,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: 120,
        meterialKouseizaiNote: null},
      {name: '地上普通型枠',
        specification: null,
        suuryou: 5000,
        tani: '㎡',
        isKatawakuSuuryou: true,
        daikuBugakari: 12,
        daikuNinku: 416.7,
        kaitaiBugakari: 40,
        kaitaiNinku: 125,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: 600,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: 120,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: 120,
        meterialKouseizaiNote: null},
      {name: '地上打放型枠',
        specification: null,
        suuryou: 2000,
        tani: '㎡',
        isKatawakuSuuryou: true,
        daikuBugakari: 12,
        daikuNinku: 166.7,
        kaitaiBugakari: 40,
        kaitaiNinku: 50,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: 800,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: 120,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: 120,
        meterialKouseizaiNote: null},
      {name: '地上化粧打放型枠',
        specification: null,
        suuryou: 2000,
        tani: '㎡',
        isKatawakuSuuryou: true,
        daikuBugakari: 8,
        daikuNinku: 250.0,
        kaitaiBugakari: 30,
        kaitaiNinku: 66.7,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: 800,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: 120,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: 120,
        meterialKouseizaiNote: null},
      {name: '捨てコン型枠',
        specification: null,
        suuryou: 500,
        tani: 'm',
        isKatawakuSuuryou: false,
        daikuBugakari: 60,
        daikuNinku: 8.3,
        kaitaiBugakari: 120,
        kaitaiNinku: 4.2,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: 1200,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: 100,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: 100,
        meterialKouseizaiNote: null},
      {name: '打継目地型枠',
        specification: null,
        suuryou: 200,
        tani: 'm',
        isKatawakuSuuryou: false,
        daikuBugakari: 60,
        daikuNinku: 3.3,
        kaitaiBugakari: 120,
        kaitaiNinku: 1.7,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: 100,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: 80,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: 80,
        meterialKouseizaiNote: null},
      {name: '誘発目地型枠',
        specification: null,
        suuryou: 300,
        tani: 'm',
        isKatawakuSuuryou: false,
        daikuBugakari: 60,
        daikuNinku: 5.0,
        kaitaiBugakari: 120,
        kaitaiNinku: 2.5,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: 80,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: 80,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: 80,
        meterialKouseizaiNote: null},
      {name: 'スタイロフォーム打込み手間',
        specification: null,
        suuryou: 200,
        tani: 'm',
        isKatawakuSuuryou: false,
        daikuBugakari: 100,
        daikuNinku: 2.0,
        kaitaiBugakari: null,
        kaitaiNinku: null,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: null,
        meterialMokuzaiNote: '材料元請支給',
        materialShoumouhinUnitPrice: 0,
        meterialShoumouhinNote: '材料元請支給',
        materialKouseizaiUnitPrice: 0,
        meterialKouseizaiNote: '材料元請支給'}
    ]
  },
  {
    id: 'materialMokuzaiUnitPrice',
    default: null,
    sample: null
  },
  {
    id: 'materialMokuzaiNote',
    default: null,
    sample: null
  },
  {
    id: 'materialShoumouhinUnitPrice',
    default: null,
    sample: null
  },
  {
    id: 'materialShoumouhinNote',
    default: null,
    sample: 'セパレータ、釘、番線他'
  },
  {
    id: 'materialKouseizaiUnitPrice',
    default: null,
    sample: null
  },
  {
    id: 'materialKouseizaiNote',
    default: null,
    sample: null
  },
  {
    id: 'daikuLaborUnitPriceType',
    default: 'Tedori',
    sample: 'Tedori'
  },
  {
    id: 'kaitaiLaborUnitPriceType',
    default: 'Tedori',
    sample: 'Tedori'
  },
  {
    id: 'daikuLaborTedoriUnitPrice',
    default: 0,
    sample: 20000
  },
  {
    id: 'daikuLaborHonninUnitPrice',
    default: 0,
    sample: 22984
  },
  {
    id: 'daikuLaborHukuriUnitPrice',
    default: 0,
    sample: 26088
  },
  {
    id: 'daikuLaborSekkeiUnitPrice',
    default: 0,
    sample: 24700
  },
  {
    id: 'daikuLaborWorkDays',
    default: 0,
    sample: 24
  },
  {
    id: 'daikuLaborHonninNenkinRyouritsu',
    default: 0,
    sample: 0.08914
  },
  {
    id: 'daikuLaborHonninKenkouRyouritsu',
    default: 0,
    sample: 0.04985
  },
  {
    id: 'daikuLaborHonninKaigoRyouritsu',
    default: 0,
    sample: 0.00420
  },
  {
    id: 'daikuLaborHonninKoyouRyouritsu',
    default: 0,
    sample: 0.00600
  },
  {
    id: 'daikuLaborKoyounushiKoyouRyouritsu',
    default: 0,
    sample: 0.01050
  },
  {
    id: 'daikuLaborKoyounushiKodomoRyouritsu',
    default: 0,
    sample: 0.00150
  },
  {
    id: 'kaitaiLaborTedoriUnitPrice',
    default: 0,
    sample: 20000
  },
  {
    id: 'kaitaiLaborHonninUnitPrice',
    default: 0,
    sample: 22984
  },
  {
    id: 'kaitaiLaborHukuriUnitPrice',
    default: 0,
    sample: 26088
  },
  {
    id: 'kaitaiLaborWorkDays',
    default: 0,
    sample: 24
  },
  {
    id: 'kaitaiLaborHonninNenkinRyouritsu',
    default: 0,
    sample: 0.08914
  },
  {
    id: 'kaitaiLaborHonninKenkouRyouritsu',
    default: 0,
    sample: 0.04985
  },
  {
    id: 'kaitaiLaborHonninKaigoRyouritsu',
    default: 0,
    sample: 0.00420
  },
  {
    id: 'kaitaiLaborHonninKoyouRyouritsu',
    default: 0,
    sample: 0.00600
  },
  {
    id: 'kaitaiLaborKoyounushiKoyouRyouritsu',
    default: 0,
    sample: 0.01050
  },
  {
    id: 'kaitaiLaborKoyounushiKodomoRyouritsu',
    default: 0,
    sample: 0.00150
  },
  {
    id: 'materialCostDetailInputMode',
    default: true,
    sample: true
  }

]



// WEBPACK FOOTER //
// ./src/company_user/libs/EstimationSchema.js